import React from 'react';

const AppIcon = () => {
  return (
    <svg
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2645 13.0987H2.40737V2.9169H10.2645M10.2645 0.0078125H2.40737C1.53522 0.0078125 0.835938 0.655085 0.835938 1.46236V14.5533C0.835938 14.939 1.0015 15.309 1.2962 15.5818C1.5909 15.8546 1.9906 16.0078 2.40737 16.0078H10.2645C10.6813 16.0078 11.081 15.8546 11.3757 15.5818C11.6704 15.309 11.8359 14.939 11.8359 14.5533V1.46236C11.8359 1.07659 11.6704 0.706619 11.3757 0.433839C11.081 0.161059 10.6813 0.0078125 10.2645 0.0078125Z"
        fill="white"
      />
    </svg>
  );
};

const DetailedHistoryIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.793527 15.0078H15.2578V13.9364H1.32924V0.0078125H0.257812V14.4721L0.793527 15.0078ZM2.40067 12.3292V3.75781L2.93638 3.2221H5.07924L5.61496 3.75781V12.3292L5.07924 12.865H2.93638L2.40067 12.3292ZM4.54353 11.7935V4.29353H3.4721V11.7935H4.54353ZM10.9721 1.61496V12.3292L11.5078 12.865H13.6507L14.1864 12.3292V1.61496L13.6507 1.07924H11.5078L10.9721 1.61496ZM13.115 2.15067V11.7935H12.0435V2.15067H13.115ZM6.68638 12.3292V5.90067L7.2221 5.36496H9.36496L9.90067 5.90067V12.3292L9.36496 12.865H7.2221L6.68638 12.3292ZM8.82924 11.7935V6.43638H7.75781V11.7935H8.82924Z"
        fill="#004B55"
      />
    </svg>
  );
};

const ViabilityIcon = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.674107 14.7321C0.845613 14.9036 1.07823 15 1.32077 15H14.8705C15.1664 15 15.4062 14.7602 15.4062 14.4643C15.4062 14.1684 15.1664 13.9286 14.8705 13.9286H8.44197C4.5957 13.9286 1.47768 10.8106 1.47768 6.96429V0.535715C1.47768 0.239848 1.23783 0 0.941964 0C0.646097 0 0.40625 0.239847 0.40625 0.535714V14.0855C0.40625 14.328 0.502601 14.5606 0.674107 14.7321ZM2.81696 12.5893C2.64546 12.4178 2.54911 12.1852 2.54911 11.9426V4.12881C2.54911 3.88626 2.64546 3.65365 2.81696 3.48214C2.98847 3.31064 3.22108 3.21429 3.46363 3.21429H4.84887C5.09142 3.21429 5.32403 3.31064 5.49554 3.48214C5.66704 3.65365 5.76339 3.88626 5.76339 4.12881V11.9426C5.76339 12.1852 5.66704 12.4178 5.49554 12.5893C5.32403 12.7608 5.09142 12.8571 4.84887 12.8571H3.46363C3.22108 12.8571 2.98847 12.7608 2.81696 12.5893ZM4.15625 11.7857C4.45212 11.7857 4.69196 11.5459 4.69196 11.25V4.82143C4.69196 4.52556 4.45212 4.28571 4.15625 4.28571C3.86038 4.28571 3.62054 4.52556 3.62054 4.82143V11.25C3.62054 11.5459 3.86038 11.7857 4.15625 11.7857ZM11.3884 1.33929C11.2169 1.51079 11.1205 1.7434 11.1205 1.98595V11.9426C11.1205 12.1852 11.2169 12.4178 11.3884 12.5893C11.5599 12.7608 11.7925 12.8571 12.0351 12.8571H13.4203C13.6628 12.8571 13.8955 12.7608 14.067 12.5893C14.2385 12.4178 14.3348 12.1852 14.3348 11.9426V1.98595C14.3348 1.7434 14.2385 1.51079 14.067 1.33929C13.8955 1.16778 13.6628 1.07143 13.4203 1.07143H12.0351C11.7925 1.07143 11.5599 1.16778 11.3884 1.33929ZM12.7277 2.14286C13.0235 2.14286 13.2634 2.3827 13.2634 2.67857V11.25C13.2634 11.5459 13.0235 11.7857 12.7277 11.7857C12.4318 11.7857 12.192 11.5459 12.192 11.25V2.67857C12.192 2.3827 12.4318 2.14286 12.7277 2.14286ZM7.10268 12.5893C6.93117 12.4178 6.83482 12.1852 6.83482 11.9426V6.27166C6.83482 6.02912 6.93117 5.79651 7.10268 5.625C7.27418 5.45349 7.5068 5.35714 7.74934 5.35714H9.13459C9.37713 5.35714 9.60974 5.45349 9.78125 5.625C9.95276 5.79651 10.0491 6.02912 10.0491 6.27166V11.9426C10.0491 12.1852 9.95276 12.4178 9.78125 12.5893C9.60974 12.7608 9.37713 12.8571 9.13459 12.8571H7.74934C7.5068 12.8571 7.27418 12.7608 7.10268 12.5893ZM8.44196 11.7857C8.73783 11.7857 8.97768 11.5459 8.97768 11.25V6.96428C8.97768 6.66842 8.73783 6.42857 8.44196 6.42857C8.1461 6.42857 7.90625 6.66842 7.90625 6.96429V11.25C7.90625 11.5459 8.1461 11.7857 8.44196 11.7857Z"
        fill="#004B55"
      />
    </svg>
  );
};

const SocialTariffIcon = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.21094 11.2078H10.7109V12.8078H4.21094V11.2078ZM4.21094 8.00781H10.7109V9.60781H4.21094V8.00781ZM9.08594 0.0078125H2.58594C1.69219 0.0078125 0.960938 0.727812 0.960938 1.60781V14.4078C0.960938 15.2878 1.68406 16.0078 2.57781 16.0078H12.3359C13.2297 16.0078 13.9609 15.2878 13.9609 14.4078V4.80781L9.08594 0.0078125ZM12.3359 14.4078H2.58594V1.60781H8.27344V5.60781H12.3359V14.4078Z"
        fill="#004B55"
      />
    </svg>
  );
};

const CreditCardIcon = () => {
  return (
    <svg
      width="35"
      height="26"
      viewBox="0 0 35 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.945312 4.78161C0.945312 2.45764 2.57339 0.75 4.37826 0.75H30.2603C32.0651 0.75 33.6932 2.45764 33.6932 4.78161V21.2184C33.6932 23.5424 32.0651 25.25 30.2603 25.25H4.37826C2.57339 25.25 0.945312 23.5424 0.945312 21.2184V4.78161Z"
        stroke="#37B482"
        strokeWidth="1.5"
      />
      <rect
        x="0.945312"
        y="5.39307"
        width="32.7479"
        height="4.07143"
        fill="#37B482"
        stroke="#37B482"
        strokeWidth="1.5"
      />
      <rect
        x="3.59096"
        y="15.5539"
        width="15.7311"
        height="1.39286"
        fill="#37B482"
        stroke="#37B482"
        strokeWidth="1.39286"
      />
      <rect
        x="3.12667"
        y="18.8034"
        width="7.64706"
        height="0.464286"
        stroke="#37B482"
        strokeWidth="0.464286"
      />
      <rect
        x="13.0485"
        y="18.8034"
        width="3.14076"
        height="0.464286"
        stroke="#37B482"
        strokeWidth="0.464286"
      />
    </svg>
  );
};

export {
  AppIcon,
  DetailedHistoryIcon,
  ViabilityIcon,
  SocialTariffIcon,
  CreditCardIcon,
};
